import React from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";

import "./PoonaWallaModal.scss";

const PoonaWallaModal = ({
  size = "md",
  handleHideModal,
  isActive,
  title,
  children,
}) => {
  return (
    <>
      <Modal size={size} centered show={isActive} onHide={handleHideModal}>
        <Modal.Body className="PoonaWallaModal p-5">
          <button
            onClick={handleHideModal}
            className="PoonaWallaModal__closebtn btn btn-sm bg-transparent"
          >
            <i className="fa fa-times" aria-hidden="true"></i>
          </button>
          {title && (
            <h4 className="PoonaWallaModal__title font-weight-bold mb-5">
              {title}
            </h4>
          )}
          {children}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PoonaWallaModal;

PoonaWallaModal.propTypes = {
  size: PropTypes.oneOf(["sm", "md", "lg", "xl"]),
  handleHideModal: PropTypes.func,
  isActive: PropTypes.bool,
  title: PropTypes.string,
  children: PropTypes.node,
};
